import {load} from '@shopify/theme-sections';
import '../sections/product-recommendations';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
